import React, { useState, useEffect } from "react";
import { Grid, Paper, Typography, makeStyles, useTheme } from "@material-ui/core";
import { Security as SecurityIcon } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import {
  getRoles,
  deleteRoles,
} from "../../store/action";
import {
  getPermission,
  fetchRolesWithPermission,
  updateRolesandPermission,
} from "../../store/action/permission/permissionAction";
import RoleList from "./RoleList";
import PermissionTree from "./PermissionTree";

const useStyles = makeStyles((theme) => ({
  root: { minHeight: "100vh" },
  paper: { padding: theme.spacing(2), background: theme.palette.background.main },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(4),
    color: theme.palette.listItem,
  },
}));

const RolePermissionManager = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [selectedRole, setSelectedRole] = useState(null);
  const [cloneRole, setCloneRole] = useState(null);
  const [selectedPermissions, setSelectedPermissions] = useState([]);

  useEffect(() => {
    dispatch(getRoles());
    dispatch(getPermission());
    dispatch(fetchRolesWithPermission());
  }, [dispatch]);

  const handleDeleteRole = async (role) => {
    const response = await dispatch(deleteRoles(role.id));
    if (response.success) {
      if (selectedRole?.id === role.id) setSelectedRole(null);
      dispatch(getRoles());
    }
  };

  const addPermission = async (role) => {
    const payload = {
      role_id: role.data.id,
      roles: role.data.id,
      permission: selectedPermissions,
    };
    await dispatch(updateRolesandPermission(payload));
    setSelectedRole(role.data);
  };
  const theme = useTheme();

  return (
    <Grid container spacing={3}>
      {/* Left Side - Role List */}
      <Grid item xs={12} md={4}>
        <Paper className={classes.paper}>
          <RoleList
            onSelectRole={setSelectedRole}
            selectedRole={selectedRole}
            onDeleteRole={handleDeleteRole}
            onCreateRole={setSelectedRole}
            onCloneRoleChange={setCloneRole}
            setSelectedRole={setSelectedRole}
            addPermission={addPermission}
          />
        </Paper>
      </Grid>

      {/* Right Side - Permission Tree */}
      <Grid item xs={12} md={8}>
        <Paper className={classes.paper}>
          {selectedRole || cloneRole ? (
            <PermissionTree
              role={selectedRole}
              cloneRole={cloneRole}
              selectedPermissions={selectedPermissions}
              setSelectedPermissions={setSelectedPermissions}
            />
          ) : (
            <div className={classes.emptyState}>
              <SecurityIcon />
              <Typography variant="h6">
                Select a role to manage permissions
              </Typography>
              <Typography variant="h6">
                Choose a role from the list to view and modify its permissions
              </Typography>
            </div>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default RolePermissionManager;
